<div class="container-details">
  <div class="back-button" nz-col nzSpan="24" [routerLink]="backLink">
    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
    {{ starterString + '.back' | translate }}
  </div>
  <div class="header">
    <i></i>
    <p class="title">{{ starterString + '.title' | translate }}</p>
  </div>
  <div class="content">
    <p class="text">{{ starterString + '.text' | translate }}</p>
  </div>
</div>
